import { IconProps } from '@va/icons';
import React from 'react';

export const ArrowsIcon = ({ color = '#969696' }: IconProps) => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3 4.5L6 1.5L9 4.5' stroke={color} strokeWidth='1.5' />
    <path d='M9 7.5L6 10.5L3 7.5' stroke={color} strokeWidth='1.5' />
  </svg>
);
